import React, { useState } from 'react';
import { Layout, Menu, Avatar, Button, Drawer } from 'antd';
import { UserOutlined, HomeOutlined, MenuOutlined } from '@ant-design/icons';
// import logo from '../../assets/logo.png'; //not yet used 
import img from '../../assets/img.svg';
import './AppHeader.css';  // Import the CSS file
import {FaUser,FaClipboardList,FaEnvelope} from 'react-icons/fa';
import { HEADER_TITLE } from '../properties/properties';
import MobileMenuHeader from './MobileMenuHeader';

const { Header } = Layout;
const AppHeader = ({scrollToSection, isMobile}) => {
    const handleMenuClick = (section) => {
        setSelection(section);
        scrollToSection.current(section);
    };

    const [selected,setSelection] = useState('Home');

    return (
        <Layout>
                {isMobile ? <MobileMenuHeader handleMenuClick={handleMenuClick} /> :
                <>
            <Header className="app-header">
                <img src={img} alt="Logo" className='app-logo'/>
                <div theme="dark" className='maintitle'>
                    {HEADER_TITLE}
                </div>
                    <Menu theme="dark" mode="horizontal" defaultSelectedKeys={['1']} className="app-menu">
                    <Menu.Item key="1" icon={<HomeOutlined />} onClick={() => handleMenuClick('Home')} className="transparent-menu-item">
                        <div className={`Homediv ${selected==='Home'?'selected':''}`}>Home</div>
                    </Menu.Item>
                    <Menu.Item key="2" icon={<FaUser/>} onClick={()=>handleMenuClick('About')} className="transparent-menu-item">
                        <div className={`AboutDiv ${selected==='About'?'selected':''}`}>About</div>
                    </Menu.Item>
                    <Menu.Item key="3" icon={<FaClipboardList/>} onClick={()=>handleMenuClick('Services')} className="transparent-menu-item">
                        <div className={`ServicesDiv ${selected==='Services'?'selected':''}`}>Services</div>
                    </Menu.Item>
                    <Menu.Item key="4" icon={<FaEnvelope/>} onClick={()=>handleMenuClick('Contact')} className="transparent-menu-item">
                        <div className={`ContactDiv ${selected === 'Contact'?'selected':''} `}>Contact us</div>
                    </Menu.Item>
                </Menu>
                <Avatar icon={<UserOutlined />} className="app-avatar" />
            </Header>
                </>}
        </Layout>
    );
};

export default AppHeader;